import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useTenantsComPermissao from "../../../../core/features/auth/tenants/useTenantsComPermissao";

export interface SelectTenantsComPermissaoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
  permissao: string;
}

function SelectTenantsComPermissao({
  value,
  onChange,
  permissao,
  ...rest
}: SelectTenantsComPermissaoProps) {
  const { isLoading, data } = useTenantsComPermissao(permissao);

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectTenantsComPermissao;
